<!--
 * @Descripttion:
 * @Author: zenghua.wang
 * @Date: 2021-04-19 16:04:45
 * @LastEditors: zenghua.wang
 * @LastEditTime: 2022-02-17 11:19:27
-->
<template>
  <div class="widget-report">
    <el-form
      label-position="left"
      label-suffix="："
      label-width="100px"
      size="small"
      :model="data"
      :rules="rules"
    >
      <el-form-item
        label="报表名称"
        prop="reportName"
      >
        <el-input
          v-model="data.reportName"
          clearable
          placeholder="请输入报表名称"
        ></el-input>
      </el-form-item>

      <el-form-item
        label="关键字"
        prop="reportKey"
      >
        <el-input
          v-model="data.reportKey"
          clearable
          placeholder="请输入报表关键字"
        ></el-input>
      </el-form-item>

      <el-form-item label="权限方式">
        <el-select
          v-model="data.authType"
          clearable
          placeholder="请选择"
          style="width:100%"
        >
          <el-option
            v-for="item in authTypeList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="角色选择">
        <!-- <universalSelector
          v-model="roleList"
          :max="0"
          type="role"
          :disabled="false"
        ></universalSelector> -->

        <vue-multiple-select
          :multiple-list="data.roleList"
          @multipleOpen="show=true"
        />

        <RoleSelect
          :visible.sync="show"
          :multiple="true"
          :backDatas="data.roleList"
          @onChecked="handleChecked"
        />
      </el-form-item>

      <el-form-item label="无权限链接">
        <el-input
          type="textarea"
          rows="2"
          v-model="data.redirect"
          clearable
          placeholder="请输入无权限跳转地址"
        ></el-input>
      </el-form-item>

      <div class="widget-version">当前版本：v{{version}}</div>
    </el-form>

  </div>
</template>

<script>
import { component } from '@/dragComponents/model/default.js'

import vueMultipleSelect from '@/dragComponents/components/vueMultipleSelect'
import { RoleSelect } from '@/framework/components/user'
const dVersion = require('@/dataReport/package.json').version

export default {
  name: 'widget-report',
  components: {
    vueMultipleSelect,
    RoleSelect
  },
  props: ['data'],
  data() {
    return {
      authTypeList: component.authType,
      show: false,
      version: dVersion,
      rules: {
        reportName: [
          { required: true, message: '请输入报表名称', trigger: 'blur' }
          // { min: 3, max: 5, message: "长度在 3 到 5 个字符", trigger: "blur" },
        ],
        reportKey: [
          { required: true, message: '请输入报表关键字', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    handleChecked(roles) {
      this.$set(this.data, 'roleList', roles)
    }
  }
}
</script>
<style lang="scss" scoped>
.widget {
  &-report {
    padding: 10px;
  }
  &-version {
    text-align: center;
    font-size: 12px;
    color: #cfcccc;
  }
}
</style>
